import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Edit } from 'components/detail';
import { SimpleForm, Toolbar } from 'components/form';
import { TextInput, HiddenInput } from 'components/input';
import { minLength, maxLength, number } from 'components/form/validate';
import { ClickEventButton, SaveButton } from 'components/button';

import linkToRecordByReplaceId from 'util/linkToRecordByReplaceId';

import { crudUpdate as crudUpdateAction } from 'actions/dataActions';

import {
  InputOptions,
  DisabledInputOptions,
} from 'util/constants';


import * as urls from './urls';


class OwnerChangeMobileBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpCountDown: 0,
    };
  }

  handleSubmit = (props, basePath) => (record) => {
    const redirectTo = linkToRecordByReplaceId(props.redirectPath, props.id);
    props.crudUpdate(props.resource, props.id, record,
      props.data, props.editBackendPath, redirectTo);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  requestOtp = () => {
    this.props.crudUpdate(
      this.props.resource, 
      this.props.id, 
      this.props.data,
      this.props.data, 
      urls.ownerInitChangeMobile, 
      '', 
      'OTP has been sent', 
      () => {
        this.setState({ otpCountDown: 60 });
        this.interval = setInterval(this.tick, 1000);
      }
    );
  };

  tick = () => {
    this.setState({ otpCountDown: this.state.otpCountDown - 1 });
    if (this.state.otpCountDown <= 0) {
      clearInterval(this.interval);
    }
  };

  render() {
    const { data } = this.props;
    const mobileToolbar = (
      <Toolbar>
        <ClickEventButton
          disabled={!!this.state.otpCountDown}
          label={this.state.otpCountDown ? `Request OTP ${this.state.otpCountDown}` : 'Request OTP'}
          onClick={this.requestOtp}
        />
        {data && data['init_token'] && <SaveButton icon={null} label="Next"/>}
      </Toolbar>
    );

    return (
      <Edit
        editBackendPath={urls.ownerChangeMobileBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm toolbar={mobileToolbar}>
          <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
          <TextInput options={DisabledInputOptions} source="owner_mobile_number" label="Owner Mobile"/>
          <TextInput
            validators={[minLength(6), maxLength(6)]}
            options={InputOptions} isRequired={true}
            source="init_otp"
            label="OTP from Old Owner Mobile"
          />
          <TextInput
            validators={[number]}
            options={InputOptions}
            isRequired={true}
            source="new_mobile_number"
            label="New Owner Mobile"
          />
          <HiddenInput source="init_token"/>
          <HiddenInput source="init_verify_code"/>
        </SimpleForm>
      </Edit>
    )
  }
}

export const OwnerChangeMobile = connect(
  (state, props) => {
    return {
      id: decodeURIComponent(props.match.params.id),
      data: state.admin[props.resource].data[decodeURIComponent(props.match.params.id)],
    };
  },
  { crudUpdate: crudUpdateAction },
)(OwnerChangeMobileBase);


export const OwnerConfirmChangeMobile = (props) => {
  return (
    <Edit editBackendPath={urls.ownerConfirmChangeMobileBackendPath} {...props}>
      <SimpleForm>
        <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
        <TextInput options={DisabledInputOptions} source="owner_mobile_number" label="Owner Mobile"/>
        <TextInput options={DisabledInputOptions} source="new_mobile_number" label="New Owner Mobile"/>
        <TextInput
          validators={[minLength(6), maxLength(6)]}
          options={InputOptions} isRequired={true}
          source="modify_otp"
          label="OTP from New Owner Mobile"
        />
        <HiddenInput source="init_otp"/>
        <HiddenInput source="init_token"/>
        <HiddenInput source="init_verify_code"/>
        <HiddenInput source="modify_token"/>
        <HiddenInput source="modify_verify_code"/>
      </SimpleForm>
    </Edit>
  )
};

// Change shop owner mobile number without otp from current mobile number
export class OwnerAdminChangeMobile extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const redirectTo = linkToRecordByReplaceId(props.redirectPath, props.id);
    props.crudUpdate(props.resource, props.id, record,
      props.data, props.editBackendPath, redirectTo);
  };

  render() {
    const mobileToolbar = (
      <Toolbar>
        <SaveButton label="Next" icon={null}/>
      </Toolbar>
    );
    return (
      <Edit
        editBackendPath={urls.ownerAdminChangeMobileBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm toolbar={mobileToolbar}>
          <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
          <TextInput options={DisabledInputOptions} source="owner_mobile_number" label="Owner Mobile"/>
          <TextInput options={InputOptions} source="new_mobile_number" label="New Owner Mobile"/>
        </SimpleForm>
      </Edit>
    )
  }
}


export class OwnerAdminConfirmChangeMobile extends Component {

  render() {
    return (
      <Edit editBackendPath={urls.ownerAdminConfirmChangeMobileBackendPath} {...this.props}>
        <SimpleForm>
          <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
          <TextInput options={DisabledInputOptions} source="owner_mobile_number" label="Owner Mobile"/>
          <TextInput options={DisabledInputOptions} source="new_mobile_number" label="New Owner Mobile"/>
          <TextInput
            validators={[minLength(6), maxLength(6)]}
            options={InputOptions} isRequired={true}
            source="otp"
            label="OTP from New Owner Mobile"
          />
          <HiddenInput source="verify_code"/>
          <HiddenInput source="token"/>
        </SimpleForm>
      </Edit>
    )

  }
}


// WEBPACK FOOTER //
// ./src/routes/shop/OwnerChangeMobile.js